import Vue from 'vue'
const REF_KEY = 'ref'

class CookieManager {
  setRef(ref) {
    Vue.cookie.set(REF_KEY, ref, { expires: 365 })
  }

  getRef() {
    return Vue.cookie.get(REF_KEY)
  }
}

export default new CookieManager()



// WEBPACK FOOTER //
// ./src/libs/cookie-manager.js